import { ASPSP } from '~/store/apis/endpoints/openBankingApi/openBanking.api';

export const getAspspByName = (aspsps: ASPSP[], aspspName: string): ASPSP => {
  const matchingAspsp = aspsps.find((_aspsp) => _aspsp.name === aspspName);
  if (!matchingAspsp) {
    throw new Error('ASPSP not found');
  }
  return matchingAspsp;
};
